import ExtendedFieldsService from "@/services/bytepro/extendedFields.service";

export const extendedFieldsApi = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    updateExtendedFields({ commit }, { fileDataId, extendedFields }) {
      return ExtendedFieldsService.updateExtendedFields(
        fileDataId,
        extendedFields
      ).then(
        (resp) => {
          commit(
            "dummy",
            "ExtendedFieldsService.updateExtendedFields - success"
          );
          return Promise.resolve(resp);
        },
        (error) => {
          commit("dummy", "ExtendedFieldsService.updateExtendedFields - error");
          return Promise.reject(error.response);
        }
      );
    },
    // updateExtendedBooleanValues(
    //   { commit },
    //   { fileDataId, extendedBooleanValues }
    // ) {
    //   return ExtendedFieldsService.updateExtendedBooleanValues(
    //     fileDataId,
    //     extendedBooleanValues
    //   ).then(
    //     (resp) => {
    //       commit(
    //         "dummy",
    //         "ExtendedFieldsService.updateExtendedBooleanValues - success"
    //       );
    //       return Promise.resolve(resp);
    //     },
    //     (error) => {
    //       commit(
    //         "dummy",
    //         "ExtendedFieldsService.updateExtendedBooleanValues - error"
    //       );
    //       return Promise.reject(error.response);
    //     }
    //   );
    // },
    // updateExtendedTextValues({ commit }, { fileDataId, extendedTextValues }) {
    //   return ExtendedFieldsService.updateExtendedTextValues(
    //     fileDataId,
    //     extendedTextValues
    //   ).then(
    //     (resp) => {
    //       commit(
    //         "dummy",
    //         "ExtendedFieldsService.updateExtendedTextValues - success"
    //       );
    //       return Promise.resolve(resp);
    //     },
    //     (error) => {
    //       commit(
    //         "dummy",
    //         "ExtendedFieldsService.updateExtendedTextValues - error"
    //       );
    //       return Promise.reject(error.response);
    //     }
    //   );
    // },
  },
  mutations: {
    dummy(state, obj) {
      console.log(obj);
    },
  },
};
